var render, staticRenderFns
import script from "./WurldDynamicTag.vue?vue&type=script&lang=js&"
export * from "./WurldDynamicTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WurldDynamicTag.vue"
export default component.exports